import * as React from 'react'
import './LoadingIndicator.scss'

export default function LoadingIndicator() {
    return (
        <div className='loadingindicator-container'>
            <sp-progress-circle indeterminate label="loading indicator"></sp-progress-circle>
        </div>
    )
}
